import SupportPanel from './SupportPanel'

SupportPanel.install = function install (Vue) {
  Vue.component(SupportPanel.name, SupportPanel)
}

export default SupportPanel



// WEBPACK FOOTER //
// ./src/components/support-panel/index.js